export const REDUX_NAMESPACE = 'DISCOVER';
